export const paging = (currentPage: number, recordPerPage: number, data: Array<any>) => {
  //logic to display data
  const indexOfLastRecord = currentPage * recordPerPage;
  const indexofFirstRecord = indexOfLastRecord - recordPerPage;
  return {
    recordsPerPage: data.slice(indexofFirstRecord, indexOfLastRecord),
    totalPage: Math.ceil(data.length / recordPerPage),
  };
};
